// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7816) return "static/chunks/7816.43ba3f37fe7ed7c2.js";
	if (chunkId === 3585) return "static/chunks/3585.132b576935751b48.js";
	if (chunkId === 4250) return "static/chunks/4250.166a94115caccc31.js";
	if (chunkId === 3715) return "static/chunks/3715.56ea1407140dba47.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2416":"cba860c348509f2c","4271":"4dab3ddd3029e7f2","6950":"4bdf4f5eb93d62ed","8103":"0174633be57b979d","8607":"ecdb036ce8692648"}[chunkId] + ".js";
};